import { SourceFinalValue, SourceKpi } from "../utils/source-kpi";
import { AccessPermissionType } from "./accessPermisionType";
import { Projet } from "./projet";
import { ReferentielDonneeAnalyse } from "./referentielDonneeAnalyse";
import { Tir } from "./tir";

export class DonneeAnalyse {
  donneeAnalyseId: number;
  siteId: number;
  referentielDonneeAnalyseId: number;
  valeur: string;
  designValue: string;
  measuredValue: string;
  nodeValue: string;
  manualValue: string;
  tirId: number;
  projetId: number;
  tir: Tir;
  projet: Projet;
  referentielDonneeAnalyse: ReferentielDonneeAnalyse;
  modeSaisie: string;
  // Afin d'afficher un message d'erreur pour un champ bien précis
  enErreur: boolean;
  autorisePourUtil: boolean;
  accessPermission: AccessPermissionType;
  isEnabled: boolean;
  sourceKpi: SourceKpi;
  sourceFinalValue: string;
  finalValue: string;

}

export class DonneeAnalyseSiteDto {
  referentielDonneeAnalyseId: number;
  unite: string;
  valeur: string;
  tirId: number;
}


export class DonneeAnalyseDTO {
  siteId: number;
  donneeAnalyseId: number;
  valeur: string;
  referentielDonneeAnalyseId: number;
  tirId: number;
  projetId: number;
}

export class KeyValue {
  key: number;
  value = '';

  constructor(key = 0, value = '') {
    this.key = key;
    this.value = value;
  }
}

export class MultiKpi {
  tirId: number;
  keyValues: KeyValue[] = [];

  constructor(tirId = 0, keyValues: KeyValue[] = []) {
    this.tirId = tirId;
    this.keyValues = keyValues;
  }
}